import React, { useState } from 'react';
import { FaSave, FaServer, FaShieldAlt, FaCreditCard, FaCog } from 'react-icons/fa';
import { showSuccess, showError, showLoading, closeLoading } from '../../../utils/Alert';
import './Settings.css';

const Settings = () => {
    const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState({
        siteName: 'AdminPro Enterprise',
        maintenanceMode: false,
        allowRegistrations: true,
        stripeEnabled: true,
        paypalEnabled: false,
        maxVideoUploadSize: '100',
        autoApproveJobs: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setConfig(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);
        showLoading('Propagating configurations...');
        setTimeout(() => {
            setLoading(false);
            showSuccess('Settings Updated', 'Global platform parameters have been committed successfully.');
        }, 500);
    };

    return (
        <div className="settings-view fade-in">
            <div className="dashboard-header">
                <h1 className="page-title">Platform & System Nodes</h1>
                <p className="page-subtitle">Configure global parameters, security protocols and integration endpoints.</p>
            </div>

            <form onSubmit={handleSave} className="settings-grid">

                {/* General Settings */}
                <div className="settings-panel">
                    <div className="panel-header">
                        <FaServer className="panel-icon" />
                        <h3 className="card-title mb-0">Platform Core</h3>
                    </div>

                    <div className="form-group">
                        <label>Application Name</label>
                        <input
                            type="text"
                            name="siteName"
                            value={config.siteName}
                            onChange={handleChange}
                            className="glass-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Max Asset Upload (MB)</label>
                        <input
                            type="number"
                            name="maxVideoUploadSize"
                            value={config.maxVideoUploadSize}
                            onChange={handleChange}
                            className="glass-input"
                        />
                    </div>

                    <div className="toggle-group">
                        <label className="toggle-label">Maintenance Mode</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="maintenanceMode"
                                checked={config.maintenanceMode}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <div className="toggle-group">
                        <label className="toggle-label">Auto-Moderate New Jobs</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="autoApproveJobs"
                                checked={config.autoApproveJobs}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>

                {/* Security & Gateways */}
                <div className="settings-panel">
                    <div className="panel-header">
                        <FaShieldAlt className="panel-icon" />
                        <h3 className="card-title mb-0">Access & Security</h3>
                    </div>

                    <div className="toggle-group">
                        <label className="toggle-label">Enable Global Registration</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="allowRegistrations"
                                checked={config.allowRegistrations}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <hr className="divider" />

                    <div className="panel-header" style={{ border: 'none', padding: '0 0 12px 0' }}>
                        <FaCreditCard className="panel-icon" />
                        <h3 className="card-title mb-0">Payment Streams</h3>
                    </div>

                    <div className="toggle-group">
                        <label className="toggle-label">Stripe (Production)</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="stripeEnabled"
                                checked={config.stripeEnabled}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <div className="toggle-group">
                        <label className="toggle-label">PayPal (Sandbox)</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="paypalEnabled"
                                checked={config.paypalEnabled}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>

                <div className="settings-actions">
                    <button type="submit" className="primary-btn pulse-on-hover" style={{ padding: '12px 32px' }} disabled={loading}>
                        {loading ? (
                            <div className="custom-spinner" style={{ width: '20px', height: '20px' }}>
                                <div className="ring ring-outer" style={{ width: '20px', height: '20px', borderRightWidth: '2px', borderTopWidth: '2px', borderLeftWidth: '2px' }}></div>
                                <div className="ring ring-middle" style={{ width: '15px', height: '15px', borderRightWidth: '2px', borderTopWidth: '2px', borderLeftWidth: '2px' }}></div>
                                <div className="ring ring-inner" style={{ width: '10px', height: '10px', borderRightWidth: '2px', borderTopWidth: '2px', borderLeftWidth: '2px' }}></div>
                            </div>
                        ) : <><FaSave style={{ marginRight: '8px' }} /> Commit Configurations</>}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Settings;
